"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultIfUndefined = function (val, defaultVal) { return val === undefined ? defaultVal : val; };
var DEFAULT_OPTIONS = {
    sequential: true
};
var getOptions = function (options) {
    if (options === undefined) {
        return {
            sequential: DEFAULT_OPTIONS.sequential
        };
    }
    return {
        sequential: getDefaultIfUndefined(options.sequential, DEFAULT_OPTIONS.sequential)
    };
};
exports.getOptions = getOptions;
